import type {MenuItemConfig} from '@myparcel-frontend/ui';
import {Support24} from '@myparcel-frontend/icons/legacy';
import {markRaw} from 'vue';

export const getSupportMenu = ({
  enableAcademy = false,
  enableFAQ = false,
  enableTellAFriend = false,
  FAQUrl = '',
}): MenuItemConfig => {
  const menuItems: MenuItemConfig = {
    type: 'parent',
    label: 'support.title',
    icon: markRaw(Support24),
    children: [
      {
        type: 'internal',
        to: {
          name: 'contact',
        },
        label: 'support.contact.title',
      },
      {
        type: 'internal',
        to: {
          name: 'cases-index',
        },
        activeRouteNameAliases: ['cases-detail'],
        label: 'support.contact.caseSummary',
      },
    ],
  };

  if (enableFAQ && FAQUrl) {
    menuItems.children.push({
      type: 'external',
      label: 'support.faq',
      href: FAQUrl,
    });
  }

  if (enableTellAFriend) {
    menuItems.children.push({
      type: 'internal',
      label: 'tellAFriend.title',
      activeRouteNameAliases: ['tellafriend-invite', 'tellafriend-edit'],
      to: {
        name: 'tellafriend',
      },
    });
  }

  if (enableAcademy) {
    menuItems.children.push({
      type: 'external',
      label: 'support.academy',
      href: 'https://www.myparcel.nl/academy',
    });
  }

  return menuItems;
};
